import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
        path: '/Login',
        component: resolve => require(['@/page/Login.vue'], resolve),
    }, {
        path: '/',
        component: resolve => require(['@/page/index.vue'], resolve),
    },
    {
        path: '/index',
        component: resolve => require(['@/page/index.vue'], resolve),
        redirect: '/mini_app/manage_banner',
        children: [
            {   // 统计数据
                path: '/school/statistics',
                component: resolve => require(['@/page/school/statistics.vue'], resolve)
            },
            {
                path: '/school/no_named',
                component: resolve => require(['@/page/school/not_named.vue'], resolve)
            },
            {   // 学校管理 - 学校列表
                path: '/school/school_list',
                component: resolve => require(['@/page/school/school_list.vue'], resolve)
            },
            {   // 学校管理 - 学校列表 - 添加学校
                path: '/school/add_school',
                component: resolve => require(['@/page/school/add_school.vue'], resolve)
            },
            {   // 学校管理 - 学校列表 - 学校概览
                path: '/school/overview',
                component: resolve => require(['@/page/school/overview.vue'], resolve)
            },
            {   // 学校管理 - 学校概览 - 授课记录
                path: '/school/teaching_records',
                component: resolve => require(['@/page/school/teaching_records.vue'], resolve)
            },
            {   // 学校管理 - 学校概览 - 授课记录 - 上课点名列表
                path: '/school/roll_call_list',
                component: resolve => require(['@/page/school/roll_call_list.vue'], resolve)
            },
            {   // 学校管理 - 学校概览 - 授课记录 - 添加排课
                path: '/school/add_class',
                component: resolve => require(['@/page/school/add_class.vue'], resolve)
            },
            {   // 学校管理 - 学校列表 - 学校概览 - 学生列表
                path: '/school/students_list',
                component: resolve => require(['@/page/school/students_list.vue'], resolve)
            },
            {   // 学校管理 - 学校列表 - 学校概览 - 专业已报名人数
                path: '/school/enroll_num',
                component: resolve => require(['@/page/school/enroll_num.vue'], resolve)
            },
            {   // 学校管理 - 学校列表 - 学生列表 - 导入学生选课
                path: '/school/import_students_course',
                component: resolve => require(['@/page/school/import_students_course.vue'], resolve)
            },
            {   // 学校管理 - 学校列表 - 学生列表 - 导入学生
                path: '/school/import_students',
                component: resolve => require(['@/page/school/import_students.vue'], resolve)
            },
            {   // 学校管理 - 学校概览 - 导入老师
                path: '/school/import_teacher',
                component: resolve => require(['@/page/school/import_teacher.vue'], resolve)
            },
            {   // 学校管理 - 学校概览 - 导入年级和班级
                path: '/school/import_grade_class',
                component: resolve => require(['@/page/school/import_grade_class.vue'], resolve)
            },
            {   // 学校管理 - 协议管理
                path: '/school/agreement',
                component: resolve => require(['@/page/school/agreement.vue'], resolve)
            },










            //首页
            {
                path: '/home/add_banner',
                component: resolve => require(['@/page/home/add_banner.vue'], resolve)
            }, // -添加轮播图-轮播图-首页
            {
                path: '/home/home_banner',
                component: resolve => require(['@/page/home/home_banner.vue'], resolve)
            }, // 轮播图 - 首页
            {
                path: '/activity/activity_manage',
                component: resolve => require(['@/page/activity/activity_manage.vue'], resolve)
            }, // 活动列表
            {
                path: '/activity/add_activity',
                component: resolve => require(['@/page/activity/add_activity.vue'], resolve)
            }, // 添加活动
            {
                path: '/activity/activity_manage_detail',
                component: resolve => require(['@/page/activity/activity_manage_detail.vue'], resolve)
            }, // 活动详情
            {
                path: '/activity/enroll',
                component: resolve => require(['@/page/activity/enroll.vue'], resolve)
            }, // 报名用户
            {
                path: '/activity/history_activity',
                component: resolve => require(['@/page/activity/history_activity.vue'], resolve)
            }, // 历史活动列表
            {
                path: '/activity/add_history_activity',
                component: resolve => require(['@/page/activity/add_history_activity.vue'], resolve)
            }, // 添加历史活动
            {
                path: '/commissioner/commissioner',
                component: resolve => require(['@/page/commissioner/commissioner.vue'], resolve)
            }, // 委员管理
            {
                path: '/commissioner/add_commissioner',
                component: resolve => require(['@/page/commissioner/add_commissioner.vue'], resolve)
            }, // 添加委员
            {
                path: '/commissioner/apply_record',
                component: resolve => require(['@/page/commissioner/apply_record.vue'], resolve)
            }, // 委员申请记录
            {
                path: '/commissioner/record_detail',
                component: resolve => require(['@/page/commissioner/record_detail.vue'], resolve)
            }, // 申请记录详情
            


            // 委员 - 通讯录 - 第X届委员会
            {
                path: '/commissioner/contact_book',
                component: resolve => require(['@/page/commissioner/contact_book.vue'], resolve)
            },
            // 委员 - 通讯录 - 添加
            {
                path: '/commissioner/add_contact_book',
                component: resolve => require(['@/page/commissioner/add_contact_book.vue'], resolve)
            },
            // 委员 - 提案
            {
                path: '/commissioner/proposal_manage',
                component: resolve => require(['@/page/commissioner/proposal_manage.vue'], resolve)
            },
            // 委员 - 提案详情
            {
                path: '/commissioner/proposal_detail',
                component: resolve => require(['@/page/commissioner/proposal_detail.vue'], resolve)
            },
            // 委员 - 线下签到列表
            {
                path: '/commissioner/underline_sign',
                component: resolve => require(['@/page/commissioner/underline_sign.vue'], resolve)
            },
            // 委员 - 留言管理
            {
                path: '/commissioner/leave_message_manage',
                component: resolve => require(['@/page/commissioner/leave_message_manage.vue'], resolve)
            },
            // 委员 - 批量导入
            {
                path: '/commissioner/batch_import_user',
                component: resolve => require(['@/page/commissioner/batch_import_user.vue'], resolve)
            },


            {
                path: '/home/welfare',
                component: resolve => require(['@/page/home/welfare.vue'], resolve)
            }, // 福利管理- 首页
            {
                path: '/home/add_welfare',
                component: resolve => require(['@/page/home/add_welfare.vue'], resolve)
            }, // 添加福利-福利管理- 首页
            {
                path: '/home/welfare_v',
                component: resolve => require(['@/page/home/welfare_v.vue'], resolve)
            }, // 福利券管理-福利管理- 首页
            {
                path: '/home/onload_welfare',
                component: resolve => require(['@/page/home/onload_welfare.vue'], resolve)
            }, // 导入福利-福利券管理-福利管理- 首页
            {
                path: '/home/get_power',
                component: resolve => require(['@/page/home/get_power.vue'], resolve)
            }, // 领取权限-福利管理- 首页
            {
                path: '/home/video',
                component: resolve => require(['@/page/home/video.vue'], resolve)
            }, // 视频管理- 首页
            {
                path: '/home/add_video',
                component: resolve => require(['@/page/home/add_video.vue'], resolve)
            }, // 视频管理- 首页
            //用户
            {
                path: '/user/user',
                component: resolve => require(['@/page/user/user.vue'], resolve)
            },
            //添加用户
            {
                path: '/user/add_user',
                component: resolve => require(['@/page/user/add_user.vue'], resolve)
            },  // 用户列表-用户
            {
                path: '/user/import_user',
                component: resolve => require(['@/page/user/import_user.vue'], resolve)
            }, // 用户列表-批量导入用户
            {
                path: '/user/user_detail',
                component: resolve => require(['@/page/user/user_detail.vue'], resolve)
            }, // 查看详情-用户列表-用户
            {
                path: '/user/get_record',
                component: resolve => require(['@/page/user/get_record.vue'], resolve)
            }, // 查看详情-用户列表-用户
            //系统
            {
                path: '/set_up/role_list',
                component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
            }, // 系统角色 - 系统
            {
                path: '/set_up/add_role',
                component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
            }, // 添加角色-系统角色 - 系统
            {
                path: '/set_up/menu_list',
                component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
            }, // 系统菜单 - 系统
            {
                path: '/set_up/add_menu',
                component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
            {
                path: '/set_up/user_list',
                component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
            {
                path: '/set_up/addStaff',
                component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
            {
                path: '/home/home_background',
                component: resolve => require(['@/page/home/home_background.vue'], resolve)
            }, // 背景图-理论学习-学习新思想-学习新思想背景图修改
            {
                path: '/home/home_content',
                component: resolve => require(['@/page/home/home_content.vue'], resolve)
            }, //内容修改-理论学习-学习新思想-习语近人管理
            {
                path: '/home/add_content',
                component: resolve => require(['@/page/home/add_content.vue'], resolve)
            }, //内容添加-理论学习-学习新思想-习语近人管理
            {
                path: '/set_up/recommend_list',
                component: resolve => require(['@/page/set_up/recommend_list.vue'], resolve)
            }, //推荐管理
            {
                path: '/set_up/add_recommend',
                component: resolve => require(['@/page/set_up/add_recommend.vue'], resolve)
            }, //推荐管理添加
            {
                path: '/home/home_manage',
                component: resolve => require(['@/page/home/home_manage.vue'], resolve)
            }, //实体书店政策及申报管理
            {
                path: '/home/home_dynamic',
                component: resolve => require(['@/page/home/home_dynamic.vue'], resolve)
            },//冬奥动态管理
            {
                path: '/home/add_dynamic',
                component: resolve => require(['@/page/home/add_dynamic.vue'], resolve)
            },//冬奥动态管理添加
            {
                path: '/home/home_comment',
                component: resolve => require(['@/page/home/home_comment.vue'], resolve)
            },//评论管理
            {
                path: '/set_up/set_search',
                component: resolve => require(['@/page/set_up/set_search.vue'], resolve)
            },//搜索关键词设置



            // PS：原来风采管理：/home/home_content?id=2&menu_id=146
            {
                path: '/home/new_style_show',
                component: resolve => require(['@/page/home/new_style_show.vue'], resolve)
            },  // 新版风采管理
            {
                path: '/home/new_add_style',
                component: resolve => require(['@/page/home/new_add_style.vue'], resolve)
            },  // 新版风采管理 - 添加内容
        ]
    },
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js